import { render, staticRenderFns } from "./roomtab.vue?vue&type=template&id=46ae2e77"
import script from "./roomtab.vue?vue&type=script&lang=js"
export * from "./roomtab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports